module.exports = __webpack_public_path__ + "img/9788956373706.b12c89d1.jpg";